import Carousel from "./simpleScroller";

const storySlider = document.querySelector(".story-slider") as HTMLElement;

if (storySlider) {
  new Carousel(storySlider);
}